import { render } from "./order-vehicle-item.vue?vue&type=template&id=9a882188&scoped=true&ts=true"
import script from "./order-vehicle-item.vue?vue&type=script&lang=ts"
export * from "./order-vehicle-item.vue?vue&type=script&lang=ts"

import "./order-vehicle-item.vue?vue&type=style&index=0&id=9a882188&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a882188"]])

export default __exports__